import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  Button,
  Checkbox,
  ColumnLayout,
  Container,
  ContentLayout,
  Flashbar,
  FormField,
  Header,
  HelpPanel,
  Input,
  Link,
  Modal,
  SideNavigation,
  SpaceBetween,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";
// import { Navigation } from "../../../components/app/Navigation";
import Icon from "@cloudscape-design/components/icon";
// import { dataUnit } from "../../dashboard/data";
// import { Grid,  } from '@cloudscape-design/components';
import DetailDashboard from "./components/DetailDashboard";
import { Navigation } from "../../../components/app/Navigation";
import { generateClient } from "aws-amplify/api";
import { updateAdmin, deleteAdmin } from "../../../graphql/mutations";
import { listAdmins } from "../../../graphql/queries";
import { ListAdminsQueryVariables } from "../../../API";
import { ListUser } from "./data/data";
import DetailOverview from "./components/DetailOverview";
import { fetchAuthSession } from "aws-amplify/auth";


// for fetching user group info 
async function checkUserGroup () {
  try{
    const {tokens} = await fetchAuthSession();
    const groups = tokens?.accessToken.payload["cognito:groups"];
    if(Array.isArray(groups)){
      return groups as string[]; 
    } else if (typeof groups === 'string'){
      return [groups];
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching user groups:", error);
    return [];
  }
}

// for fetching user info 
async function checkCurrentUser(): Promise<{username : string ; email: string | null }> {
  try {
    const {tokens} = await fetchAuthSession();
    const currentUser = tokens?.idToken?.payload || tokens?.accessToken?.payload;
    if (currentUser) {
      const username = typeof currentUser["cognito:username"] === 'string'
      ? currentUser["cognito:username"] : "";
      const email = typeof currentUser.email === 'string'
      ? currentUser.email : null;
      return {username, email};
    } else{
      console.error("No user information found");
      return {username : "", email: null};
    }
  } catch (error) {
    console.error("error fetching current user information :", error)
    return{username : '', email : null}
  }
}


interface FlashbarItem {
  type: "info" | "warning" | "error" | "success"; // Adjust according to your requirements
  dismissible: boolean;
  dismissLabel: string;
  onDismiss: () => void;
  content: React.ReactNode;
  id: string;
}

async function deleteAdminApi(id: string) {
  try {
    const client = generateClient();
    await client.graphql({
      query: deleteAdmin,
      authMode: "userPool",
      variables: {
        input: {
          id,
        },
      },
    });
  } catch (err) {
    console.log("Error deleting Admin: ", err);
  }
}

async function updateAdminApi(
  id: string,
  nik: string,
  name: string,
  email: string,
  position: string,
  tenant: string,
  username: string,
  password: string,
  accessrole: string
) {
  try {
    const client = generateClient();
    await client.graphql({
      query: updateAdmin,
      authMode: "userPool",
      variables: {
        input: {
          id: id,
          nik: nik,
          name: name,
          email: email,
          position: position,
          tenant: tenant,
          username: username,
          password: password,
          accessrole: accessrole,
        },
      },
    });
  } catch (err) {
    console.log("Error updating user: ", err);
  }
}

const UserDetail: React.FC = () => {
  const [activeHref, setActiveHref] = React.useState("/admin/users");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const { name } = useParams<{ name: string }>();
  const [isModalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [isModalUpdateVisible, setModalUpdateVisible] = useState(false);
  const [itemsFlashbar, setItemsFlashbar] = useState<FlashbarItem[]>([]);
  const [itemsFlashbar2, setItemsFlashbar2] = useState<FlashbarItem[]>([]);
  const navigate = useNavigate();
  let { NIK } = useParams();
  const [userList, setUserList] = useState<ListUser[]>([]);
  const userIdRef = useRef<string | null>(null);
  const [adminNIK, setadminNIK] = useState("");
  const [adminName, setadminName] = useState("");
  const [adminEmail, setadminEmail] = useState("");
  const [adminPosition, setadminPosition] = useState("");
  const [adminTenant, setadminTenant] = useState("");
  const [adminUsername, setadminUsername] = useState("");
  const [adminPassword, setadminPassword] = useState("");
  const [adminAccessrole, setadminAccessrole] = useState("");
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [userGroups, setUserGroups]= useState<string[]>([]);
  const [currentUser, setCurrentUser]= useState<string>("");
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");

  // for timestamp
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hours = String(now.getHours()).padStart(2,"0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

  useEffect(() => {
    async function initialize () {
      fetchUser();
      const groups = await checkUserGroup();
      const user = await checkCurrentUser();
      setCurrentUser(user.username);
      setCurrentUserEmail(user.email ?? "");
      setUserGroups(groups);
    }
    initialize();
  }, []);

  const fetchUser = async (limit = 100) => {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allAdmins: ListUser[] = [];

      do {
        const variables: ListAdminsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listAdmins,
          authMode: "userPool",
          variables,
        });
        const admins = response.data.listAdmins.items;
        nextToken = response.data.listAdmins.nextToken ?? null;

        const newAdmins: ListUser[] = admins.map((admin: any) => ({
          id: admin.id,
          NIK: admin.nik ?? "",
          Name: admin.name ?? "",
          Email: admin.email ?? "",
          Position: admin.position ?? "",
          tenant: admin.tenant ?? "",
          Username: admin.username ?? "",
          Password: admin.password ?? "",
          AccessRole: admin.accessrole ?? "",
        }));

        allAdmins = [...allAdmins, ...newAdmins];
      } while (nextToken);

      const filteredUsers = allAdmins.filter((admin) => admin.NIK === NIK);
      setUserList(filteredUsers);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching user : ", err);
      setItemsFlashbar([
        {
          type: "error",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar([]),
          content: "Error fetching user data.",
          id: "message_3",
        },
      ]);
    }
  };

  const handleDelete = async () => {
    setModalDeleteVisible(false);
    if (userList.length > 0) {
      const userIdToDelete = userList[0].id;
      await deleteAdminApi(userIdToDelete);
      // for transaction log 
      console.log(
        `Admin Transaction Log (Delete item):
        Admin Id : ${userIdToDelete}
        Admin NIK : ${userList[0].NIK}
        User Group : ${userGroups}
        user : ${currentUser}
        User Email : ${currentUserEmail}
        Timestamp : ${timestamp}
        `
      )
      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "User successfully deleted.",
          id: "message_4",
        },
      ]);
      navigate("/admin/users");
    }
  };
  const handleUpdate = async () => {
    setModalUpdateVisible(false);
    if (userList.length > 0) {
      const userIdToDelete = userList[0].id;
      await updateAdminApi(
        userIdToDelete,
        adminNIK,
        adminName,
        adminEmail,
        adminPosition,
        adminTenant,
        adminUsername,
        adminPassword,
        adminAccessrole
      );
      // for transaction log 
      console.log(
        `Admin Transaction Log (Update Item)
        Admin ID : ${userIdToDelete}
        Admin NIK : ${adminNIK}
        User Group : ${userGroups}
        User : ${currentUser}
        User Email : ${currentUserEmail}
        Timestamp : ${timestamp}`
      )
      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "User successfully updated.",
          id: "message_5",
        },
      ]);
      fetchUser(); // Refresh the vehicle list after update
    }
  };
  const handleEditButtonClick = () => {
    setModalUpdateVisible(true);
    if (userList.length > 0) {
      const adminn = userList[0];

      setadminNIK(adminn.NIK);
      setadminName(adminn.Name);
      setadminEmail(adminn.Email);
      setadminPosition(adminn.Position);
      setadminTenant(adminn.tenant);
      setadminUsername(adminn.Username);
      setadminPassword(adminn.Password);
      setadminAccessrole(adminn.AccessRole);
    }
  };

  const handleDeleteConfirmation = () => {
    setModalDeleteVisible(true);
  };

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Admin",
                href: "/admin",
              },
              {
                text: "User Detail",
                href: "/admin/users",
              },
              {
                text: `Detail User NIK : ${NIK}`,
                href: `/user/detail/${NIK}`,
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
            // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                actions={
                  <SpaceBetween size='s' direction='horizontal'>
                    <Button onClick={handleEditButtonClick}>Edit</Button>
                    <Button onClick={handleDeleteConfirmation}>Delete</Button>
                  </SpaceBetween>
                }
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/admin/users" ? `NIK : ${NIK}` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{marginTop: isLoading ? "160px" : "0px"}}>
              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading user details...</Box>
                </Box>
              ) : (
                <Container>
                  <Flashbar items={itemsFlashbar2} />
                  <ColumnLayout columns={2} minColumnWidth={500}>
                    <div>
                      <div>
                        <h1>User Profile </h1>
                        <h3>NIK : {NIK}</h3>
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <Flashbar items={itemsFlashbar} />
                      </div>
                      {userList.length > 0 ? (
                        userList.map((admin) => (
                          <ColumnLayout
                            key={admin.NIK}
                            borders='horizontal'
                            columns={2}
                          >
                            <div>Name</div>
                            <div style={{ fontWeight: "bold" }}>
                              {admin.Name}
                            </div>
                            <div>Email</div>
                            <div style={{ fontWeight: "bold" }}>
                              {admin.Email}
                            </div>
                            <div>Postition</div>
                            <div>{admin.Position}</div>
                            <div>Tenant</div>
                            <div>{admin.tenant}</div>
                            <div>Username</div>
                            <div>{admin.Username}</div>
                            <div>Password</div>
                            <div>{admin.Password}</div>
                            <div>Access Role</div>
                            <div>{admin.AccessRole}</div>
                          </ColumnLayout>
                        ))
                      ) : (
                        <div>No User data found.</div>
                      )}
                    </div>

                    <DetailOverview />
                  </ColumnLayout>
                </Container>
              )}
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
      <Modal
        onDismiss={() => setModalDeleteVisible(false)}
        visible={isModalDeleteVisible}
        closeAriaLabel='Close modal'
        header='Confirm Delete'
        footer={
          <SpaceBetween direction='horizontal' size='s'>
            <Button variant='link' onClick={() => setModalDeleteVisible(false)}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleDelete}>
              Confirm
            </Button>
          </SpaceBetween>
        }
      >
        <p>Are you sure you want to delete this User?</p>
      </Modal>
      <Modal
        onDismiss={() => setModalUpdateVisible(false)}
        visible={isModalUpdateVisible}
        footer={
          <Box float='right'>
            <SpaceBetween direction='horizontal' size='xs'>
              <Button
                variant='link'
                onClick={() => setModalUpdateVisible(false)}
              >
                Cancel
              </Button>
              <Button variant='primary' onClick={handleUpdate}>
                Submit
              </Button>
            </SpaceBetween>
          </Box>
        }
        header='Edit User'
      >
        <Container>
        <SpaceBetween direction='vertical' size='l'>
            <FormField label='NIK'>
              <Input
                value={adminNIK}
                onChange={({ detail }) => setadminNIK(detail.value)}
              />
            </FormField>
            <FormField label='Name'>
              <Input
                value={adminName}
                onChange={({ detail }) => setadminName(detail.value)}
              />
            </FormField>
            <FormField label='Email'>
              <Input
                value={adminEmail}
                onChange={({ detail }) => setadminEmail(detail.value)}
              />
            </FormField>
            <FormField label='Position'>
              <Input
                value={adminPosition}
                onChange={({ detail }) => setadminPosition(detail.value)}
              />
            </FormField>
            <FormField label='Tenant'>
              <Input
                value={adminTenant}
                onChange={({ detail }) => setadminTenant(detail.value)}
              />
            </FormField>
            <FormField label='Username'>
              <Input
                value={adminUsername}
                onChange={({ detail }) => setadminUsername(detail.value)}
              />
            </FormField>
            <FormField label='Password'>
              <Input
                value={adminPassword}
                onChange={({ detail }) => setadminPassword(detail.value)}
              />
            </FormField>
            <FormField label='Access Role'>
              <Input
                value={adminAccessrole}
                onChange={({ detail }) => setadminAccessrole(detail.value)}
              />
              {/*<Select
                options={[
                  { label: "Admin", value: "1" },
                  { label: "User", value: "2" },
                  { label: "Operator", value: "3" },
                ]}
                selectedOption={null}
              />*/}
            </FormField>
            </SpaceBetween>
        </Container>
      </Modal>
    </>
  );
};

export default UserDetail;
